import * as Yup from 'yup';
import { AssertSchemaMatchesModel, validateContract } from '../validateContract';
import { BetterBeWidgetPayload } from './betterBePayload.model';

// Structural containers and identifying fields are required; descriptive/UI fields are optional to
// avoid false-positive logs.
const equipmentSchema = Yup.object({
  schema: Yup.object({
    code: Yup.string().required(),
    title: Yup.string().optional(),
    type: Yup.string().optional(),
    unit: Yup.string().nullable().defined(),
  }).required(),
  values: Yup.array(
    Yup.object({
      value: Yup.mixed<string | number>().required(),
      type: Yup.string().optional(),
      location: Yup.string().nullable().defined(),
    }).required()
  ).required(),
});

export const betterBePayloadSchema = Yup.object({
  vehicle: Yup.object({
    catalogVehicle: Yup.object({
      vehicleId: Yup.mixed<string | number>().optional(),
    }).optional(),
    options: Yup.array(
      Yup.object({
        optionId: Yup.number().required(),
        orderCode: Yup.string().required(),
        price: Yup.object({
          basePrice: Yup.number().nullable().optional(),
          retailPrice: Yup.number().nullable().optional(),
        }).required(),
        type: Yup.string().required(),
        description: Yup.string().nullable().defined(),
        equipment: Yup.array(equipmentSchema).required(),
        title: Yup.string().optional(),
        isAccessory: Yup.boolean().optional(),
        packMembers: Yup.mixed().nullable(),
      }).required()
    ).required(),
    equipment: Yup.array(equipmentSchema).required(),
  }).required(),
  price: Yup.object({
    amountEx: Yup.number().required(),
    amountInc: Yup.number().required(),
  }).required(),
});

export type BetterBePayloadFromSchema = AssertSchemaMatchesModel<
  BetterBeWidgetPayload,
  Yup.InferType<typeof betterBePayloadSchema>
>;

export const validateBetterBePayload = (payload: unknown): boolean =>
  validateContract(betterBePayloadSchema, payload, 'BetterBe');
